import { ArrayLayoutProps, isObjectArrayControl, RankedTester, rankWith } from "@jsonforms/core";
import { withJsonFormsArrayLayoutProps } from "@jsonforms/react";

import ArrayRendererMain from "../ArrayRenderer";

export const ArrayLayoutRenderer = (props: ArrayLayoutProps) => <ArrayRendererMain {...props} />;

export const arrayLayoutTester: RankedTester = rankWith(4, isObjectArrayControl);

export default withJsonFormsArrayLayoutProps(ArrayLayoutRenderer);
